import React from "react";
import { Route, Routes } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import AuthLayout from "./layouts/authOwnerLayout/AuthLayout";
import EventLiveScreen from "./pages/events/EventLiveScreen";
import { AfterLogin, Protected_routes, Required_auth } from "./utils/Utils";
import {
  Login,
  PageNotFound,
  Dashboard,
  Events,
  EventDetail,
  EventLogistics,
  UserManagement,
  Transactions,
  LegalInformation
} from "./pages";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route
          path="/"
          element={
            <AfterLogin>
              <Login />
            </AfterLogin>
          }
        />
        <Route
          path="/login"
          element={
            <AfterLogin>
              <Login />
            </AfterLogin>
          }
        />
      </Route>
       {/* FULLSCREEN LIVE */}
      <Route
        path="/events/live/:id"
        element={
          <Protected_routes>
            <EventLiveScreen />
          </Protected_routes>
        }
      />
      <Route element={<Required_auth />}>
        <Route>
          <Route
            element={
              <Protected_routes>
                <AuthLayout />
              </Protected_routes>
            }
          >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:id" element={<EventDetail />} />
              <Route path="/event-logistics" element={<EventLogistics />} />
              <Route path="/user-management" element={<UserManagement />} />
              <Route path="/transactions" element={<Transactions />} />
              <Route path="/legal-information" element={<LegalInformation />} />
              {/* <Route path="/auth/users-edit/:id" element={<EditUser />} /> */}
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
